export function zenkakuToHankaku(str: string): string {
  return str.replace(/[！-～]/g, function(str: string) {
    return String.fromCharCode(str.charCodeAt(0) - 0xfee0);
  });
}
